import script from "./ModuleColumnsSettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleColumnsSettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./ModuleColumnsSettingsModal.vue?vue&type=style&index=0&id=2bcf3d58&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bcf3d58"]])

export default __exports__